<template>
  <div class="trackplayer">
<!--     <DatePicker :editable="false" style="position: absolute;top:10%;left:50%;transform: translateX(-50%);opacity: 0;pointer-events: none;" placement="bottom" :transfer="true" :value="timeRange" :open="visibleTimePicker" type="datetimerange" placeholder="选定历史轨迹"  @on-change="handleChangeHistory" @on-ok="handleLoadHistory"></DatePicker> -->

    <div class="trackplayer-controller">
      <div @click="play" style="margin: 0 8px;">
        <Icon :type="playBtnIcon" color="#fefcfa" size="24" />
      </div>
      <!-- <div><Icon type="ios-skip-backward" color="#fefcfa" size="20" /></div> -->
<!--       <div style="margin: 0 8px;">
        <Icon type="ios-skip-forward" color="#fefcfa" size="18" />
      </div> -->
      <!-- <div class="track-time">{{metadata.currentTime}}</div> -->
      <Slider class="progress player" :min="0" :step="1" :max="metadata.duration" :value="currentProgress" @on-input="handleSeeking" :tip-format="tipFormat" @on-change="handleSeeked"></Slider>
      <div class="track-op">
        <a v-html="timeRangeLabel"></a>
        <Dropdown trigger="click" @on-click="handleChangeSpeed">
          <a>{{speedRateLabel}}</a>
          <DropdownMenu slot="list">
            <DropdownItem name="1.0">1.0X</DropdownItem>
            <DropdownItem name="1.5">1.5X</DropdownItem>
            <DropdownItem name="2.0">2.0X</DropdownItem>
            <DropdownItem name="3.0">3.0X</DropdownItem>
            <DropdownItem name="5.0">5.0X</DropdownItem>
            <DropdownItem name="10.0">10.0X</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!-- <a @click="handleChangeView">{{viewModeLabel}}</a> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    speedRateLabel() {
      if (this.speedRate) {
        return this.speedRate + 'X'
      } else {
        return '倍速'
      }
    },
    timeRangeLabel() {
      if (this.timeRange && this.timeRange.length) {
        return this.timeRange.join('<br />')
      } else {
        return '选择时段'
      }
    },
    viewModeLabel() {
      return this.viewMode == '2D' ? '3D' : '2D'
    },

    playBtnIcon() {
      return this.metadata.playing ? 'ios-pause' : 'ios-play'
    }
  },
  data() {
    return {
      speedRate: null,
      visibleTimePicker: false,
      historyPoint: 0,
      viewMode: '2D',
      currentProgress: 0,
      seeking: false,
    }
  },

  props: {
    timepicker:{
      type:Boolean,
      default:false
    },
    timeRange:{
      type:Array,
      default:function(){
        return []
      }
    },

    metadata: {
      type: Object,
      default: function() {
        return {
          currentProgress: 0,
          duration: 1,
          currentTime: '',
          playing: false,
          routes: []
        }
      }
    }
  },
  watch: {
    timepicker(v){
      console.log('timepicker >>>' , v)
      if(v === true){
        this.visibleTimePicker = true
      }else if ( v === false){
        this.visibleTimePicker = false
      }
    },
    'metadata.currentProgress'(nv, ov) {
      this.currentProgress = nv
    }
  },
  methods: {
    tick(data) {

    },
    tipFormat(v) {
      if (this.metadata.routes && this.metadata.routes[v]) {
        return this.metadata.routes[v]
      } else {
        return null
      }
    },
    reset() {
      
    },
    play(){
      if( this.metadata.routes.length ){
        this.$emit('play')
      }
    },
    handleStartDrag() {
      console.log('start drag')
    },

    handleChangeSpeed(name) {
      this.speedRate = parseFloat(name)
      this.$emit('change-speed', this.speedRate)
    },


    handleEmit(type) {
      this.$emit(type)
    },
    handleChangeView() {
      this.$emit('change-viewmode')
    },

    handleSeeking(p) {
      if (p && p != this.currentProgress) {
        this.$emit('seeked', p)
      }
    },
    handleSeeked(p) {
      console.log('seeked')

      if (p && p != this.currentProgress) {
        this.$emit('seeked', p)
      }
    }
  },
}

</script>
<style lang="scss">
.trackplayer{
  // position:absolute;
  // width: 100%;height:100%;left:0;right:0;
}
.trackplayer-controller {
  display: flex;
  align-items: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 0 5px;
  background: rgba(0, 0, 0, .45);
  z-index: 1000;

  a {
    color: #fefcfa;
  }

  .track-time {
    color: #fefcfa;
    margin: 0 15px;
  }

  .track-op {
    display: flex;
    align-items: center;
    position: relative;
    height: 17px;
    color: #999;
    font-size: 11px;
    padding-left: 7px;

    &>* {
      min-width: 50px;
      text-align: center;
    }

  }

  .progress {
    flex: auto;
  }


  .timepicker {
    // .ivu-date-picker-rel{
    //   // display: none;
    //   position:absolute;
    //   top:50% !important;left:50% !important;
    //   transform: translate(-50%,-50%);
    // }

    // position:fixed;
    // top:50%;left:50%;
    // transform: translate(-50%,-50%);
    // position:absolute;
    // right:0;
    // bottom:0;
    // display: none;
  }
}


.player {
  .ivu-slider-wrap {
    height: 2px;
  }

  .ivu-slider-bar {
    height: 2px;
  }
}

</style>
